module.exports = __webpack_public_path__ + "media/assets/icons/icon_calculator-simple-e552816ca2dfd64fb50c18bca19b902d.svg";